/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { hooksServerNamesUpsertServerNameOverride } from "../funcs/hooksServerNamesUpsertServerNameOverride.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ServerNameOverride } from "../models/components/servernameoverride.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  UpsertServerNameOverrideRequest,
  UpsertServerNameOverrideSecurity,
} from "../models/operations/upsertservernameoverride.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type HooksServerNamesUpsertServerNameOverrideMutationVariables = {
  request: UpsertServerNameOverrideRequest;
  security?: UpsertServerNameOverrideSecurity | undefined;
  options?: RequestOptions;
};

export type HooksServerNamesUpsertServerNameOverrideMutationData =
  ServerNameOverride;

export type HooksServerNamesUpsertServerNameOverrideMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * upsert hooksServerNames
 *
 * @remarks
 * Create or update a server name display override
 */
export function useHooksServerNamesUpsertServerNameOverrideMutation(
  options?: MutationHookOptions<
    HooksServerNamesUpsertServerNameOverrideMutationData,
    HooksServerNamesUpsertServerNameOverrideMutationError,
    HooksServerNamesUpsertServerNameOverrideMutationVariables
  >,
): UseMutationResult<
  HooksServerNamesUpsertServerNameOverrideMutationData,
  HooksServerNamesUpsertServerNameOverrideMutationError,
  HooksServerNamesUpsertServerNameOverrideMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildHooksServerNamesUpsertServerNameOverrideMutation(client, options),
    ...options,
  });
}

export function mutationKeyHooksServerNamesUpsertServerNameOverride(): MutationKey {
  return ["@gram/client", "hooksServerNames", "upsertServerNameOverride"];
}

export function buildHooksServerNamesUpsertServerNameOverrideMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: HooksServerNamesUpsertServerNameOverrideMutationVariables,
  ) => Promise<HooksServerNamesUpsertServerNameOverrideMutationData>;
} {
  return {
    mutationKey: mutationKeyHooksServerNamesUpsertServerNameOverride(),
    mutationFn: function hooksServerNamesUpsertServerNameOverrideMutationFn({
      request,
      security,
      options,
    }): Promise<HooksServerNamesUpsertServerNameOverrideMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(hooksServerNamesUpsertServerNameOverride(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
